import React, { useEffect, lazy, Suspense } from "react";
import { saveRef } from "./lib/api";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Header from "./components/site/Header";
import Footer from "./components/site/Footer";
import Home from "./pages/Home";
import Tarifs from "./pages/Tarifs";
import Proprietaires from "./pages/Proprietaires";
import Contact from "./pages/Contact";
import RendezVous from "./pages/RendezVous";
import Villes from "./pages/Villes";
import VillePage from "./pages/VillePage";
import ServicePage from "./pages/ServicePage";
import ServiceHub from "./pages/ServiceHub";
import OptionPage from "./pages/OptionPage";
import PrixPage from "./pages/PrixPage";
import QuartierPage from "./pages/QuartierPage";
import { Toaster } from "./components/ui/sonner";
import WhatsAppButton from "./components/site/WhatsAppButton";
import Faq from "./pages/Faq";
import QuiSommesNous from "./pages/QuiSommesNous";
import { HelmetProvider } from "react-helmet-async";
import RouteSeo from "./components/site/RouteSeo";
const Logos = lazy(() => import("./pages/Logos"));
const MentionsLegales = lazy(() => import("./pages/MentionsLegales"));
const Cgv = lazy(() => import("./pages/Cgv"));
const Confidentialite = lazy(() => import("./pages/Confidentialite"));
const Admin = lazy(() => import("./pages/Admin"));
const Espace = lazy(() => import("./pages/Espace"));
const EspacePresentation = lazy(() => import("./pages/EspacePresentation"));
const Demarrer = lazy(() => import("./pages/Demarrer"));
const ContratSigner = lazy(() => import("./pages/ContratSigner"));
const RendezVousModifier = lazy(() => import("./pages/RendezVousModifier"));
const Parrainage = lazy(() => import("./pages/Parrainage"));
const OwnerLogin = lazy(() => import("./pages/EspaceAuth").then((m) => ({ default: m.OwnerLogin })));
const OwnerActivate = lazy(() => import("./pages/EspaceAuth").then((m) => ({ default: m.OwnerActivate })));

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function RefCapture() {
  const { search } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const code = new URLSearchParams(search).get("parrain");
    if (!code) return;
    saveRef(code.toUpperCase());
    navigate(`/parrainage/${code.toUpperCase()}`, { replace: true });
  }, [search, navigate]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollTop />
        <RefCapture />
        <RouteSeo />
        <Header />
        <main>
          <Suspense fallback={<div className="min-h-screen" />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tarifs" element={<Tarifs />} />
            <Route path="/proprietaires" element={<Proprietaires />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/logos" element={<Logos />} />
            <Route path="/rendez-vous" element={<RendezVous />} />
            <Route path="/rendez-vous/modifier/:token" element={<RendezVousModifier />} />
            <Route path="/villes" element={<Villes />} />
            <Route path="/parrainage/:code" element={<Parrainage />} />
            <Route path="/villes/:slug" element={<VillePage />} />
            <Route path="/villes/:slug/:service" element={<ServicePage />} />
            <Route path="/services/:service" element={<ServiceHub />} />
            <Route path="/options/:slug" element={<OptionPage />} />
            <Route path="/options/:slug/:city" element={<OptionPage />} />
            <Route path="/prix-conciergerie/:slug" element={<PrixPage />} />
            <Route path="/conciergerie/:slug" element={<QuartierPage />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/cgv" element={<Cgv />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/qui-sommes-nous" element={<QuiSommesNous />} />
            <Route path="/demarrer/:plan" element={<Demarrer />} />
            <Route path="/contrat/signer/:token" element={<ContratSigner />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/espace-proprietaire" element={<Espace />} />
            <Route path="/espace-proprietaire/decouvrir" element={<EspacePresentation />} />
            <Route path="/espace-proprietaire/connexion" element={<OwnerLogin />} />
            <Route path="/espace-proprietaire/activer/:token" element={<OwnerActivate />} />
          </Routes>
          </Suspense>
        </main>
        <Footer />
        <WhatsAppButton />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
